export const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const KEY_STORAGE = "oxylog_admin_key";
export const PAGE_SIZE = 25;

export const STATUSES = [
  { value: "nouveau", label: "Nouveau" },
  { value: "rapport_envoye", label: "Rapport envoyé" },
  { value: "rdv_pris", label: "RDV pris" },
  { value: "cloture", label: "Clôturé" },
];

export function statusLabel(value) {
  return (STATUSES.find((s) => s.value === value) || STATUSES[0]).label;
}

export function getAdminKey() {
  return localStorage.getItem(KEY_STORAGE) || "";
}

export function authHeaders(key) {
  return { "X-Admin-Key": key };
}

export function lvl(score) {
  if (score >= 80) return "high";
  if (score >= 50) return "mid";
  return "low";
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.toLocaleDateString("fr-FR")} ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
}

export async function adminFetch(path, key, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { ...(options.headers || {}), ...authHeaders(key) },
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try { detail = (await res.json()).detail || detail; } catch (e) { /* ignore */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res;
}

export async function downloadBlob(path, key, fallbackName) {
  const res = await adminFetch(path, key);
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const m = cd.match(/filename="?([^";]+)"?/);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
